import React, { lazy, Suspense, useEffect } from 'react';
import { useSetAtom } from 'jotai';
import { selectedClientIdAtom } from '@/state/clients';
import { feedsInDisplayAtom } from '@/features/camera-feeds/atoms';
import { CameraGridSkeleton } from '@/components/camera';
import { usePodRoomConnection } from '../hooks/usePodRoomConnection';

// Lazy load FeedGrid
const FeedGrid = lazy(() =>
  import('./FeedGrid').then((module) => ({
    default: module.FeedGrid,
  })),
);

interface FeedContainerProps {
  propertyId: string;
}

export const FeedContainer: React.FC<FeedContainerProps> = ({ propertyId }) => {
  const setSelectedClientId = useSetAtom(selectedClientIdAtom);
  const setFeedsInDisplay = useSetAtom(feedsInDisplayAtom);

  // Initialize pod room connection functionality
  usePodRoomConnection();

  // Initialize property and clear feeds
  useEffect(() => {
    console.log('FeedContainer: Property changed to:', propertyId);
    setSelectedClientId(propertyId);
    setFeedsInDisplay([]);
  }, [propertyId, setSelectedClientId, setFeedsInDisplay]);

  return (
    <Suspense fallback={<CameraGridSkeleton />}>
      <FeedGrid />
    </Suspense>
  );
};
